/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['@charset "UTF-8";'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9zZXJ2aWNlL3Njc3MvbWl4aW5zLmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zdG9yYWdlL3Zob3N0L3BhbmVsLmRhdGFzcGFjZS5wbC93ZWIvZGF0YXNwYWNlLWNwLWRzLWZyb250L3NyYy9hcHAvc2VydmljZS9zZXJ2aWNlLW9mZmVyLXBheW1lbnQuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/service/scss/mixins.css.shim.ngstyle.ts